import request from "../utils/request.js";
export const login = async (username, password) => {
  try {
    const response = await request({
      url: '/login',
      method: 'POST',
      data: { username, password },
    });
    if (response.token) {
      const expiresAt = Date.now() + 660 * 60 * 1000; 

      localStorage.setItem('company_token', response.token);
      localStorage.setItem('company_token_expires_at', expiresAt.toString());
    }
    return response;
  } catch (error) {
    console.error('Login failed:', error);
    return null;
  }
};
export const checkNewUser = async (username,password) => {
  try {
    const response = await request({
      url: '/checkNewUser',
      method: 'POST',
      params: { username ,password},
    });
    return response;
  } catch (error) {
    console.error('Login failed:', error);
    return null;
  }
};

export const checkUser = async (username) => {
  try {
    const response = await request({
      url: '/checkUser',
      method: 'POST',
      params: { username },
    });
    return response;
  } catch (error) {
    console.error('Login failed:', error);
    return null;
  }
};

export const adminChangePassword = async (username) => {
  try {
    const response = await request({
      url: '/adminChangePassword',
      method: 'POST',
      params: { username },
    });
    return response;
  } catch (error) {
    console.error('Admin change password failed:', error);
    return null;
  }
}
export const changePassword = async (password, username) => {
  try {
    const response = await request({
      url: '/changePassword',
      method: 'POST',
      params: { password, username },
    });
    if (response.token) {
      const expiresAt = Date.now() + 660 * 60 * 1000; 
      localStorage.setItem('company_token', response.token);
      localStorage.setItem('company_token_expires_at', expiresAt.toString());
    }
    return response;
  } catch (error) {
    console.error('Login failed:', error);
    return null;
  }
}
export const sendCode = async (username) => {
  try {
    const response = await request({
      url: '/sendCode',
      method: 'POST',
      params: { username },
    });
    return response;
  } catch (error) {
    console.error('Login failed:', error);
    return null;
  }
}
export const verifyCode = async (username, code, password) => {
  try {
    const response = await request({
      url: '/verifyCode',
      method: 'POST',
      params: { username, code, password },
    });
    return response;
  } catch (error) {
    console.error('Login failed:', error);
    return null;
  }
}
export const logout = async () => {
  await request({
    url: '/logout',
    method: 'POST',
  });
  localStorage.removeItem('company_token');
  localStorage.removeItem('company_token_expires_at');
};

export const whoami = async () => {
  try {
    const response = await request({
      url: '/system/user/check',
      method: 'GET',
    });
    return response;
  } catch (error) {
    console.error('Failed to fetch user info:', error);
    return null;
  }
}
